/**
 * j file delete <id>
 * Delete an uploaded file
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { ConfigService } from '../../services/config.service.js';
import { FileService } from '../../services/file.service.js';

export function createFileDeleteCommand(): Command {
    return new Command('delete')
        .description('Delete uploaded file')
        .argument('<id>', 'File ID to delete')
        .option('-j, --json', 'JSON output')
        .action(async (id: string, opts) => {
            try {
                const configService = new ConfigService();
                const config = await configService.load();
                if (!config) {
                    console.error(chalk.red('Chưa đăng nhập. Chạy "j auth" trước.'));
                    process.exit(1);
                }

                const service = new FileService();
                await service.delete(config, parseInt(id));

                if (opts.json) {
                    console.log(JSON.stringify({ success: true, id: parseInt(id) }));
                } else {
                    console.log(chalk.green(`✓ Đã xóa file #${id}`));
                }

            } catch (error) {
                console.error(chalk.red(`Lỗi: ${error instanceof Error ? error.message : String(error)}`));
                process.exit(1);
            }
        });
}
